import { useEffect, useRef } from 'react';
import {
    initialValues,
    isOrbitDefensorConsumidor,
    validationSchema,
} from './formData';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitChannelFormProps } from '../sectionProps';

export const useOrbitChannelForm = ({
    onChangeFormik,
    readOnly,
    seedValues,
    seedChannel,
}: OrbitChannelFormProps) => {
    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
        readOnly,
        seedValues,
    });

    const channelSeeded = useRef(false);

    useEffect(() => {
        if (channelSeeded.current || readOnly || !seedChannel) return;
        if (formik.values.orbitChannel) return;
        channelSeeded.current = true;
        formik.setFieldValue('orbitChannel', seedChannel);
    }, [seedChannel, readOnly, formik.values.orbitChannel]);

    useEffect(() => {
        if (readOnly || isOrbitDefensorConsumidor(formik.values.orbitChannel)) {
            return;
        }
        if (
            !formik.values.sfcAdmission &&
            !formik.values.correspondenceFiling
        ) {
            return;
        }
        formik.setFieldValue('sfcAdmission', '');
        formik.setFieldValue('correspondenceFiling', '');
    }, [formik.values.orbitChannel, readOnly]);

    return { formik };
};
